import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import { DtwinLifeCycleState } from "~/modules/dtwin/models/DtwinLifeCycleState.enum";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";

function canTransitionToState(
  dtwinModel: DtwinModel,
  currentState: DtwinLifeCycleState,
  targetState: DtwinLifeCycleState,
) {
  const transitions = dtwinModel.lifeCycle.transitions.filter((transition) =>
    transition.to.includes(targetState),
  );

  return transitions.some((transition) => transition.from === currentState);
}

export function canEnableDisableDtwin(dtwin: Dtwin, dtwinModel?: DtwinModel) {
  // can enable the device if it is disabled
  if (dtwin.lifeCycleState === DtwinLifeCycleState.DISABLED) {
    return true;
  }
  // base on the device model transitions, can disable the device if a transition exists from the current life cycle state to the disabled state
  else if (dtwinModel) {
    return canTransitionToState(
      dtwinModel,
      dtwin.lifeCycleState,
      DtwinLifeCycleState.DISABLED,
    );
  }
}
